import React, { useState, useEffect } from "react";
import hover_matches_list from "../../assets/svgs/hover_matches_list.svg";
import { Tooltip, ClickAwayListener } from "@mui/material";
import { orderDetailsTableStyle as styles } from "./purchaseHistory.tailwind";

const OrderDetailsTable = ({ tokenDetails }) => {
  const [openTooltips, setOpenTooltips] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  // State to control tooltip visibility for each tokenId
  const handleTooltipOpen = (tokenId) => {
    setOpenTooltips((prev) => ({ ...prev, [tokenId]: true }));
  };

  const handleTooltipClose = (tokenId) => {
    setOpenTooltips((prev) => ({ ...prev, [tokenId]: false }));
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (

    <div className={styles.container}>
      <table className={styles.table}>
        <thead>
          {/* token details table headings */}
          <tr className="whitespace-nowrap b-bottom grid grid-cols-3">
            <th className={styles.innerTableHead}>Token Name</th>
            <th className={styles.innerTableHead}>Zone</th>
            {/* <th className={styles.innerTableHead}>Purchase Type</th> */}
            <th className={styles.innerTableHead}>Price</th>
          </tr>
        </thead>
        <tbody>
          {/* token details like token name, zone, purchase type, price */}
          {tokenDetails?.map((token, index) => (
            <tr
              key={index}
              className={`${styles.innerTableBody} ${
                index === tokenDetails.length - 1 ? "" : styles.border
              } ${styles.innermainTableBody}`}
            >
              {/* to display token name */}
              <td className={styles.innerTableBody}>
                <span>#{token.tokenName?.split('-')?.length > 0 ? token?.tokenName?.split('-')[token?.tokenName?.split('-')?.length - 1] : "" || "N/A"}</span>
              </td>
              <td className={styles.innerTableBody}>
                <span>{token.zoneName}</span>
              </td>
              {/* Purchase Type - either Entire Season(purchase type- 1) or Per Match(purchase type-2) */}
              {/* <td className={styles.innerTableBody}>
                {token.purchaseType === "1" ? (
                  "Entire Season"
                ) : (
                  <>
                    {isMobile ? (
                      <ClickAwayListener onClickAway={() => handleTooltipClose(token.tokenId)}>
                        <Tooltip
                          title={<ToolTipContent matchIds={token.matchIds} />}
                          arrow
                          placement="top"
                          open={!!openTooltips[token.tokenId]}
                          PopperProps={{
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [0, 8],
                                },
                              },
                            ],
                          }}
                        >
                          <span
                            className="cursor-pointer"
                            onClick={() => handleTooltipOpen(token.tokenId)}
                          >
                            Per Match
                          </span>
                          
                        </Tooltip>
                      </ClickAwayListener>
                    ) : (
                      
                        <div className="flex gap-1">
                          <span>
                            Per Match
                          </span>
                          <Tooltip title={<ToolTipContent matchIds={token.matchIds} />} arrow>
                            <img src={hover_matches_list} alt=""  className="cursor-pointer" />
                          </Tooltip>
                        </div>
                    )}
                  </>
                )}
              </td> */}

              {/* Price */}
              <td className={styles.innerTableBody}>
                ${token.adjustedTokenPrice?.toFixed(2)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OrderDetailsTable;

// Tooltip Content Component
const ToolTipContent = ({ matchIds }) => (
  <div>
    <strong>Match Details:</strong>
    <ul>
      {matchIds?.map((match, i) => (
        <li key={i} className='flex gap-1'>
          <strong>Team:</strong> {match.awayTeamName || "N/A"}
          <img src={hover_matches_list} alt="{ match.awayTeamName }" />
        </li>
      ))}
    </ul>
  </div>
);